import { gql } from "@apollo/client";

export const UPDATE_SERVICE = gql`
  mutation UpdateService($data: UpdateServiceInputData!) {
    updateService(data: $data) {
      message
      statusCode
    }
  }
`;
